import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthServerProvider} from '../../../../block/auth/auth-jwt.service';
import {WelcomeService} from '../../../welcome/welcome.service';

@Component({
  selector: 'app-password-reset-init',
  templateUrl: './password-reset-init.component.html'
})
export class PasswordResetInitComponent implements OnInit {

  error: string;
  success: string;
  regularForm: FormGroup;

  event: any;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private authService: AuthServerProvider,
    private welcomeService: WelcomeService,
  ) { }

  ngOnInit() {
    this.welcomeService.getEventDetail().subscribe((resEvent: any) => {
      this.event = resEvent;
    });
    this.regularForm = this.fb.group({
      username: [null, [Validators.required, Validators.email]]
    })
  }

  reset() {
    this.authService.initResetPassword(this.regularForm.getRawValue()).subscribe(() => {
      this.router.navigate(['/login']);
    });
  }
}
